export { isLandscape, isPortrait } from './platformOrientationModes/platformOrientationModes/index.js';
export { textOverflowHidden } from './textOverflowHidden/textsOverflowHidden/index.js';
export { hideScrollbars } from './hideScrollbars/hideScrollbars/index.js';
export { placeholderShown, placeholders } from './placeholders/placeholders/index.js';
export { canHover, canTouch } from './hoverTouch/hoverTouch/index.js';
export { mediaQuery } from './mediaQuery/mediaQuery/index.js';
export { withFocusTrap } from './focusTrap/focusTrap/index.js';
export { scrollbar } from './scrollbar/scrollbar/index.js';
export { supports, supportsNot } from './supports/supports/index.js';
export { ignoreRTL, isLeftToRight, isRightToLeft } from './rtl/rtl/index.js';
